import { RootState } from '../../../store';

export const getUser = (state: RootState) => state.user.currentUser;
export const getUserLoading = (state: RootState) => state.user.isLoading;
